import { Action } from '@ngrx/store';
import { LicencesAndPermissions } from '@account-users/account/models/LicensePermissionList';

export enum UserLicensesActionTypes {
  LoadAllLicenses = '[Permissions] Load All Licenses',
  LoadAllLicensesSuccess = '[Permissions] Load All Licenses Success',
  LoadAllLicensesFailed = '[Permissions] Load All Licenses Failed',
}

export class LoadAllUserLicenses implements Action {
  readonly type = UserLicensesActionTypes.LoadAllLicenses;
}

export class LoadAllUserLicensesSuccess implements Action {
  readonly type = UserLicensesActionTypes.LoadAllLicensesSuccess;
  constructor(public payload: LicencesAndPermissions) {}
}

export class LoadAllUserLicensesFailed implements Action {
  readonly type = UserLicensesActionTypes.LoadAllLicensesFailed;
}

export type LicensesActions =
  | LoadAllUserLicenses
  | LoadAllUserLicensesSuccess
  | LoadAllUserLicensesFailed;
